<template>
  <div>
    <div class="form_item" :class="save_to+'_wrapper'">
      <div :id="save_to+'_element'">
        <Label :required="required" :label="label" :for_id="save_to"/>
        <input
          v-validate="validation"
          :id="save_to"
          :name="validationLabel || label"
          :key="save_to"
          :ref="save_to"
          :required="required"
          inputmode="tel"
          type="tel"
          :autocomplete="(autocomplete)?'tel':undefined"
          :class="{'has-error': errors.has(label)}"
          :placeholder="placeholder"
          @change="onChange"
        />
      </div>
      <p v-if="info !== undefined" class="info" v-html="info"></p>
      <span
        class="error"
        v-show="errors.has(label) && ((fields[label].untouched && !fields[label].dirty) || (fields[label].touched && fields[label].dirty))"
        v-text="errors.first(label)"
      ></span>
    </div>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';
import Label from './Label'
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export default {
  name: 'Input',
  mixins: [validatorComponent],
  data: function () {
    return {
      validation : {unique: false},
    }
  },
  components: {
    Label
  },
  props: {
    save_to: String,
    unique: Boolean,
    _id : String,
    validationRules: Object,
    autocomplete: Boolean,
    validationLabel: String,
    placeholder: String,
    acceptedCountries: Array,
    defaultCountry: String,
    phoneType: String,
  },
  methods: {
    onChange($event) {
      let phoneNumber = parsePhoneNumberFromString($event.target.value, this.defaultCountry);
      if(phoneNumber) {
        this.$emit('input', phoneNumber.formatInternational());
      }
    }
  },
  created() {
    if(this.unique) {
      this.validation = {...this.validationRules, unique: [this.save_to, this._id]};
    } else {
        this.validation = {...this.validationRules}
    }
    this.validation.phone = {
      phoneType: this.phoneType,
      defaultCountry: this.defaultCountry,
      acceptedCountries: this.acceptedCountries
    }
  },
  mounted() {
    this.$refs[this.save_to].value = this.val || "";
  }
};
</script>
